import { defineComponent as n, openBlock as o, createBlock as r, unref as i, withCtx as a, createElementVNode as l } from "vue";
import f from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as c } from "@storefront-ui/shared";
const u = /* @__PURE__ */ n({
  __name: "SfIconWarning",
  props: {
    size: {
      type: String,
      default: c.base
    }
  },
  setup(t) {
    return (d, e) => (o(), r(i(f), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "warning"
    }, {
      default: a(() => e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M10.258 4.067c.764-1.363 2.725-1.363 3.49 0l7.818 13.95c.748 1.333-.216 2.978-1.744 2.978H4.183c-1.528 0-2.492-1.645-1.745-2.978zM12 8a1 1 0 0 1 1 1v3.5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m0 7.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
